﻿// Import general mixin for shared functionality.
import mixin from './mixin';
import ApiSourceSet from './components/ApiSourceSet.vue';

// Import axios for API consuming in a clean interface.
const axios = require('axios');

import Swiper, { Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

import { swiperConfig } from '../functions.js';

const newsWidgetApp = {
    mixins: [mixin],
    components: { ApiSourceSet },
    data() {
        return {
            dataApi: '',
            dataLimit: 6,
            dataGuid: '',
            dataLanguage: '',

            loading: false,
            data: null,
        }
    },
    computed: {
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        queryParams() {
            const urlParams = new URLSearchParams();
            urlParams.set('newsOverviewNodeId', this.dataGuid);
            urlParams.set('cultureCode', this.dataLanguage);
            urlParams.set('limit', this.dataLimit);
            return urlParams.toString();
        },
    },
    methods: {
        async init() {
            this.loading = true;

            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
            if (this.$el.dataset.guid) this.dataGuid = this.$el.dataset.guid;
            if (this.$el.dataset.language) this.dataLanguage = this.$el.dataset.language;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit); 

            const response = await this.fetchData();
            this.setData(response);

            this.loading = false;
        },
        async fetchData() {
            try {
                const response = await axios.get(`${this.dataApi}?${this.queryParams}`);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        async loadMore() {
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
        },
        setData(response) {
            if (!response || response.status != 200) return;
            this.data = response.data;
        },
    },
    async mounted() {
        await this.init();
        this.slider = new Swiper(this.$refs.swiper, {
            ...swiperConfig,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.prev
            },
            breakpoints: {
                640: {
                    slidesPerView: 2.2,
                },
                1024: {
                    slidesPerView: 3.2,
                },
                1216: {
                    slidesPerView: 4.2,
                },
            },
        })
    },
};

export default newsWidgetApp;
